/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Lists_AvailableInputs */



/**
* | output |
* | --- |
* | "No lists available." |
*
* @param {No_Lists_AvailableInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_lists_available = /** @type {((inputs?: No_Lists_AvailableInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Lists_AvailableInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune liste disponible.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Es sind keine Listen verfügbar.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun elenco disponibile.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Списки отсутствуют.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay listas disponibles")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("暂无列表。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("利用可能なリストはありません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कोई सूची उपलब्ध नहीं है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Nenhuma lista disponível.")
	return /** @type {LocalizedString} */ ("No lists available.")
});